module.exports = __webpack_public_path__ + "img/form-1.48e0c3a8.png";